type TreeIO = {
  readdir(path: string): Promise<string[]>
  stat(path: string): Promise<{isDirectory(): boolean, isFile(): boolean}>
  readFile(path: string, encoding: 'utf8'): Promise<string>
}
/** Retain namespace-relative paths: item/gilded_palm/9100 is not item/9100. */
export async function readModelTree(root: string, prefix: string, namespace: string, io: TreeIO) {
  const models: Record<string, any> = {}
  const textures = new Set<string>()
  async function visit(relative: string) {
    const directory = relative ? `${root}/${relative}` : root
    for (const file of await io.readdir(directory)) {
      const nested = relative ? `${relative}/${file}` : file
      const full = `${root}/${nested}`
      const stat = await io.stat(full)
      if (stat.isDirectory()) { await visit(nested); continue }
      if (!stat.isFile() || !file.endsWith('.json')) continue
      const parsed = JSON.parse(await io.readFile(full, 'utf8'))
      const name = `${prefix ? prefix + '/' : ''}${nested.slice(0, -5)}`
      if (namespace === 'minecraft') models[name] = parsed
      models[`${namespace}:${name}`] = parsed
      for (const value of Object.values(parsed.textures ?? {})) {
        if (typeof value !== 'string' || value.startsWith('#')) continue
        textures.add(value.includes(':') ? value : `minecraft:${value}`)
      }
    }
  }
  await visit('')
  return {models, textures}
}
